import { render, staticRenderFns } from "./m-blue-intro.vue?vue&type=template&id=3b675ff7&scoped=true&"
import script from "./m-blue-intro.vue?vue&type=script&lang=ts&"
export * from "./m-blue-intro.vue?vue&type=script&lang=ts&"
import style0 from "./m-blue-intro.vue?vue&type=style&index=0&id=3b675ff7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b675ff7",
  null
  
)

export default component.exports